import { InlineLoader } from '../page-loader/styled-components'

export const AsyncLoaderComponent = <InlineLoader />
